import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import api from '@appbase/api'
import { mapGetters, mapMutations } from 'vuex';
import * as appbaseTypes from '@appbase/store/types'
import * as types from '@home/store/types'
import localStorageHelper from '@appbase/util/local-storage-helper'
const EumCookiePrefix = ".EumDoNotPopup_"

@Component({
    components: {

    },
    computed: {
        ...mapGetters({
            isTeams: appbaseTypes.TEAMS,
            modalPopupItem: types.NOTICEPOPUP_MODAL_GET,
            modalPopupList: types.NOTICEPOPUP_MODAL_LIST_GET
        })
    } ,
    methods:{
        ...mapMutations({
            setTeams : appbaseTypes.TEAMS,
            setModalIdx: types.NOTICEPOPUP_MODAL_IDX_SET
        })
    }
})
export default class NoticePreviewView extends Vue {
    setTeams! : (value:boolean) => void
    setModalIdx! : (value:number) => void

    isTeams!: boolean
    

    popupItem?: noticepopup.NoticeItem | noticepopup.ModalNoticeItem
    modalPopupItem!: noticepopup.ModalNoticeItem
    isChecked: boolean = false

    modalPopupList!: noticepopup.ModalNoticeList
    totalPage:number = 1
    page:number = 1

    created() {
        // 테스트용 팀즈set
        // this.setTeams(true)

        if (this.isTeams == false) {

            let objData;

            if(this.$route.query.popupItem){
                const strData = <string>this.$route.query.popupItem
                const jsonData = decodeURIComponent(strData)
                objData = JSON.parse(jsonData)
            }
            if(this.$route.query){
                if(this.$route.query.htmlContent){
                    var obj = localStorageHelper.get(`$home/${this.$route.query.popupId}/htmlcontent`);
                    objData = JSON.parse(obj);
                }
            }
            if (objData) {
                //Created 라이프사이클에서는 ref 로 iframe 에 접근 할 수 없는 시점 데이터만 처리          
                this.popupItem = objData
            }
        } else { //팀즈인경우
            this.popupItem = this.modalPopupItem
            if(this.modalPopupList && this.modalPopupList.items.length>1) {
                this.popupItem = this.modalPopupList.items[0]
                this.totalPage = this.modalPopupList.items.length
            }
        }

    }

    mounted() {
        this.initData()
    }

    initData(){
        //dom 그려지는 시점에서 데이터 입력
        if (this.popupItem) {
            //브라우저인경우만 타이틀 변경
            if(this.isTeams == false) window.document.title = this.popupItem.title

            let iframe = <HTMLIFrameElement>this.$refs.iframeRef;

            if (this.popupItem.noticePopupType == 1) {
                if (iframe.contentDocument) {
                    iframe.contentDocument.body.innerHTML = this.popupItem.noticePopupContents
                }
            } else {
                //this.popupItem.fileCode
                api.file.getFiles(this.popupItem.fileCode).then(result => {
                    let imgUrl = ""
                    if (result.length > 0) {
                        imgUrl = result[0].downloadUrl
                    } else {
                        // C:\NAS\gres\images\img_not_found.jpg

                        imgUrl = "/cm/gres/images/img_not_found.jpg"
                    }

                    if (iframe.contentDocument) {
                        iframe.contentDocument.body.innerHTML = `<img style='width:100%;height:100%' src='${imgUrl}' />`
                    }
                })
                //let imgEle = `<img src="${this.popupItem.}"`
            }
        }
        //타이틀 변경

        // window.document.title = objData.title
        //     console.log(objData)

        //     //에디터 입력 데이터
        //     if(objData.noticePopupType == "1"){
        //         let iframe = this.$refs.iframeRef
        //         debugger
        //         // noticePopupContents
        //     }else{ //첨부 파일


        //     }
    }

    changeModalPage(){
        this.popupItem = this.modalPopupList.items[this.page-1]
        this.setModalIdx(this.page-1)
        this.initData();
    }

    close() {
        window.close()
    }


    /**
     * 관리자 페이지에서는 대상아님
     */
    @Watch("isChecked")
    onChangedCheckedOption() {
        let expires = new Date()
        //체크된 상태 
        //쿠키 하루 + popupId 
        if (this.isChecked == true) {
            //앞으로 하루가 아니라 오늘까지만 유효 
            expires.setHours(23, 59, 59, 999)
        } else {//만료시켜버림
            expires.setHours(0, 0, 0, 0)
        }
        document.cookie = `${EumCookiePrefix}_${this.popupItem?.noticePopupId}=DONOTPOPUP;path=/; expires=${expires}`
    }

    @Watch('page')
    onChangeModalPage(val:number){
        if(val>0 && this.page > this.totalPage){
            this.page = 1
        }
        else if(val<0 && this.page == 0){
            this.page = this.modalPopupList.items.length
        }
        this.changeModalPage()
    }
}
